<dl class="sheet-facts">
  @if (generalInfo?.title) {
    <div>
      <dt>Titolo</dt>
      <dd>{{ generalInfo?.title }}</dd>
    </div>
  }
  @if (generalInfo?.code) {
    <div>
      <dt>Codice</dt>
      <dd>{{ generalInfo?.code }}</dd>
    </div>
  }
  @if (generalInfo?.obj_region?.definition) {
    <div>
      <dt>Codice regione</dt>
      <dd>{{ generalInfo?.obj_region?.definition }}</dd>
    </div>
  }
  @if (generalInfo?.generale_catalog_number) {
    <div>
      <dt>Numero catalogo generale</dt>
      <dd>{{ generalInfo?.generale_catalog_number }}</dd>
    </div>
  }
  @if (generalInfo?.storage_place) {
    <div>
      <dt>Luogo di conservazione</dt>
      <dd>{{ generalInfo?.storage_place }}</dd>
    </div>
  }
</dl>

@if (generalInfo && hasPlacement(generalInfo)) {
  <dl class="sheet-facts sheet-place row g-3">
    @if (generalInfo.floor != null) {
      <div class="col-6">
        <dt>Piano</dt>
        <dd>{{ generalInfo.floor }}</dd>
      </div>
    }
    @if (generalInfo.room != null) {
      <div class="col-6">
        <dt>Stanza</dt>
        <dd>{{ generalInfo.room }}</dd>
      </div>
    }
    @if (generalInfo.rack != null) {
      <div class="col-6">
        <dt>Scaffale / armadio</dt>
        <dd>{{ generalInfo.rack }}</dd>
      </div>
    }
    @if (generalInfo.case != null) {
      <div class="col-6">
        <dt>Contenitore</dt>
        <dd>{{ generalInfo.case }}</dd>
      </div>
    }
    @if (generalInfo.shelf != null) {
      <div class="col-6">
        <dt>Ripiano</dt>
        <dd>{{ generalInfo.shelf }}</dd>
      </div>
    }
  </dl>
}
